import React from 'react';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { Invitation } from './components/Invitation';
import { CoSpine } from './components/CoSpine';
import { House } from './components/House';
import { Leaders } from './components/Leaders';
import { Locations } from './components/Locations';
import { Quote } from './components/Quote';
import { Waitlist } from './components/Waitlist';
import { Footer } from './components/Footer';
import { StickyCTA } from './components/StickyCTA';
export function App() {
  return <div className="w-full min-h-screen bg-paper text-ink" data-id="element-0">
      <Nav data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Invitation data-id="element-4" />
        <CoSpine data-id="element-5" />
        <House data-id="element-6" />
        <Leaders data-id="element-7" />
        <Locations data-id="element-8" />
        <Quote data-id="element-9" />
        <Waitlist data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
      <StickyCTA data-id="element-12" />
    </div>;
}